import axios from "axios";

const obituaryService = axios.create({
  baseURL:
    "https://apierp-funeraria.invitatech.com.br:2007/api/funerarias/funerais/export",
});

export default obituaryService;
